<template>
    <div v-if="SlotObj">
  
      <!-- {{getTimeDisplay(SlotObj.slot_start_ts)}} -->
      <button v-if="SlotObj.capacity < 1" type="button"
        class="w-full text-center text-gray-300 m-1 border rounded-md border-gray-300 p-1 sm:px-3 sm:py-2 text-xs cursor-not-allowed">
        <div class="flex-nowrap">
          {{getTimeDisplay(SlotObj.slot_start_ts)}}
        </div>
        <div>
          已约满
        </div>
      </button>
      <button v-else-if="selectedAppointmentSlot == SlotObj.slot_start_ts" type="button"
        class="w-full items-center rounded-md bg-primaryBtnHover border border-primaryBtn p-2 text-sm font-light text-white shadow-sm ">
        <div>
          {{getTimeDisplay(SlotObj.slot_start_ts)}}
        </div>

        <div class="font-bold">
          已选择
        </div>
      </button>
  
      <button v-else @click="setSelectedAppointmentSlot(SlotObj.slot_start_ts)" type="button"
        class="w-full items-center rounded-md border border-primaryBtn/70 hover:bg-primaryBtn/80 hover:text-white p-2 text-sm font-light text-primaryText shadow-sm"> 
            <div class="flex-nowrap">{{getTimeDisplay(SlotObj.slot_start_ts)}}</div>
            <div>可预约</div>
            
      </button>
      
      
  
      
    </div>
  </template>
  
  <script setup>
const {
    tergetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest, selectedApptDate, SetSelectedApptDate, getAppointmentSlots, AppointmentSlots, setAppointmentSlots, selectedAppointmentSlot, setSelectedAppointmentSlot
} = usePatientAppointmentRequest()
  
      const props = defineProps ({
          SlotObj: Object
      })
  
        let getTimeDisplay =  (ts) => {
          let date = new Date(ts)
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var ampm = hours >= 12 ? '下午' : '上午';
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? '0'+minutes : minutes;
          var strTime = ampm + ' ' + hours + ':' + minutes ;
          return strTime;
        }
      
  
    
  
  </script>
  
  <style>
  
  </style>